<template>
  <div class="moon-phase white-wrapper mt-3">
    <h5 class="mb-3 font-weight-bold border-bottom pb-2">
      <img src="https://vk.com/emoji/e/f09f8c96_2x.png" class="title-icon"/>
      Лунная фаза
    </h5>

    <div :class="{
      'moon-phase__info-positive': isPositivePhase,
      'moon-phase__info-negative': isNegativePhase}"
         class="moon-phase__info" v-if="isPositivePhase || isNegativePhase">

      <div v-if="isPositivePhase">
        <img src="https://vk.com/emoji/e/f09f918d_2x.png" class="moon-phase__info_icon"/>
        <span>Благоприятная фаза</span>
      </div>

      <div v-if="isNegativePhase">
        <img src="https://vk.com/emoji/e/f09f9981_2x.png" class="moon-phase__info_icon"/>
        <span>Неблагоприятная фаза</span>
      </div>
    </div>

    <div class="moon-phase__description">
      <p>{{ sentences[0] }}</p>
      <accordion>
        <div slot="body">
          <p v-for="s in sentences.slice(1, sentences.length)" :key="s.length + Math.random()">
            {{ s }}
          </p>
        </div>
      </accordion>
    </div>
  </div>
</template>

<script>
import {store} from "@/store";
import stringHelper from "@/lib/string";
import Accordion from "@/components/_Utlis/Accordion";

export default {
  name: "MoonPhaseWidget",
  components: {Accordion},
  data() {
    return {
      sentences: [],
    }
  },
  created() {
    this.sentences = stringHelper.generateText(this.moonPhaseData);
  },
  computed: {
    moonPhaseData() {
      return store.state.moonDayInfo["description_phase_moon"];
    },
    isPositivePhase() {
      return store.state.moonDayInfo["favorability_phase"] === "positive";
    },
    isNegativePhase() {
      return store.state.moonDayInfo["favorability_phase"] === "negative";
    },
  }
}
</script>

<style lang="scss" scoped>
  .title-icon {
    width: 16px;
    height: auto;
    margin-top: -3px;
  }
  .moon-phase__info {
    text-align: center;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 12px;
    font-weight: 500;
    padding: 4px 10px;
    border: 1px solid #bdbdbd;
    border-radius: 5px;
    margin-bottom: 14px;
    color: #333;

    & img {
      margin-right: 7px;
    }
  }

  .moon-phase__info-positive {
    background: #c8e6c9;
    border-color: #a5d6a7;
  }

  .moon-phase__info-neutral {
    background: #f5f5f5;
    border-color: #eeeeee;
  }

  .moon-phase__info-negative {
    background: #ffcdd2;
    border-color: #ef9a9a;
  }

  .moon-phase__info-description {

  }

  .moon-phase__info_icon {
    width: 16px;
    height: auto;
    margin-top: -4px;
  }
</style>